// src/utils/deviceHealth.js
// Pure health-derivation helpers. See plan "Health model (authoritative)".

export const HEALTH_LABEL = { online: 'Online', degraded: 'Degraded', offline: 'Offline' };

export function deviceHealth(activeCount, totalPacks, statusFallback) {
  const active = activeCount || 0;
  const total = totalPacks || 0;
  if (total > 0) {
    if (active >= total) return 'online';
    if (active > 0) return 'degraded';
    return 'offline';
  }
  return statusFallback === 'online' ? 'online' : 'offline';
}

export function aggregateHealth(rows) {
  let onlinePacks = 0, totalPacks = 0;
  let onlineDevices = 0, degradedDevices = 0, offlineDevices = 0;
  (rows || []).forEach((r) => {
    const active = r.activeCount || 0;
    const total = r.totalPacks || 0;
    onlinePacks += active;
    totalPacks += total;
    const h = deviceHealth(active, total, r.status);
    if (h === 'online') onlineDevices += 1;
    else if (h === 'degraded') degradedDevices += 1;
    else offlineDevices += 1;
  });
  return {
    onlinePacks,
    offlinePacks: Math.max(0, totalPacks - onlinePacks),
    totalPacks,
    onlineDevices,
    degradedDevices,
    offlineDevices,
  };
}
